module.exports = __webpack_public_path__ + "static/media/SL-Dummy.9764f215.jpg";